import { t } from "components/CentralDataMangement/translation/Translation";
import type { JobInterviewDetails} from "../Annotations";
import { StarterDetails } from "../Annotations";
import TableTitle from "components/common/atoms/TableTitle";
import Tick from "static/images/Tick";

interface JobInterviewTableProps {
    view?: "recruiter" | "tl";
    data?: JobInterviewDetails[];
    tableTitle?: string;
}
const JobInterviewTable: React.FC<JobInterviewTableProps> = ({ view = "recruiter", data, tableTitle }) => {

    return (
        <>
            {tableTitle &&
                <TableTitle title={tableTitle} />
            }
            <div className="starter-table-height marginBotttom1 scrollBarDesign">
                <table className="table table-hover table-bordered targetTable">
                    <thead>
                        <tr className="TableHeader">
                            <th>{t("Date")}</th>
                            <th>{t("Company")}</th>
                            <th>{t("Name UZK")}</th>
                            {view === "tl" ? (<>
                                <th>{t("Info")}</th>
                                <th>{t("FRO recruiter")}</th>
                                <th>{t("Result")}</th>
                                <th>{t("Office")}</th>
                            </>) : (<>
                                <th>{t("Starter")}</th>
                            </>)}
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length && data?.length > 0 ? (
                            data?.map((candidate: JobInterviewDetails, index) => (
                                <tr key={index}>
                                    <td className="align-middle">{candidate.date}</td>
                                    <td className="align-middle">{candidate.company}</td>
                                    <td className="align-middle">{candidate.candidate}</td>
                                    {view === "tl" ? (<>
                                        <td className="align-middle">{candidate?.info}</td>
                                        <td className="align-middle">{candidate?.recruiter}</td>
                                        <td className="align-middle">{candidate?.result}</td>
                                        <td className="align-middle">{candidate?.office}</td>
                                    </>) : (<>
                                        <td className="table-action-icons align-middle text-center">{candidate?.becameStarter ? <Tick /> : ""}</td>
                                    </>)}
                                </tr>
                            ))) : (
                            <tr>
                                <td colSpan={view === "tl" ? 7 : 4}>
                                    <div className="text-danger text-center">
                                        {t("No data found")}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default JobInterviewTable;